import { BaseService } from './../../../services/base.service';
import { Observable } from 'rxjs/internal/Observable';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class MapService {

	// private readonly _getMapDataRequestEndpoint: string = "GetMapData";

	// public getMapData(
	// 	minifiedSelections: MinifiedSelection[],
	// 	filtersOperator: FiltersOperator,
	// 	periodType: string
	// ): Observable<SelectStatementResult> {
	// 	let url = `map/${this._getMapDataRequestEndpoint}?${MinifiedselectionUtils.convertFiltersToURLQuery(minifiedSelections)}&${filtersOperator.toURLQuery()}&periodType=${periodType}`;

	

	getCountryCodeByLatLong(latitude: number, longitude: number, accessToken: string): Observable<any> {
		let url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${longitude},${latitude}.json?access_token=${accessToken}&limit=1&types=country`;

		return this._baseService.getOuter(url);
	}

	constructor(
		private _baseService: BaseService,
	) { }
}
